export const environment = {
  production: true,
  // apiUrl: "http://localhost:34029/api",
  apiUrl: "https://app-woodcareplanner-eastus2-dev-002-g3dth8fgcvbndja4.eastus2-01.azurewebsites.net/api",
  name: "dev",
  siteName: 'ppsstainselector',
  facebookUrl: 'http://ppsstainapp-app-stg.ppgac.com',
  pinterestUrl: 'http://pps11stg.ppgac.com/woodcareplanner'
 };



// WEBPACK FOOTER //
// ./src/environments/environment.ts